import type { FilterConditions } from './useMynaviStateMachine'

/**
 * フィルター条件を API パラメータに変換する。
 * @param conditions フィルター条件
 * @param q 学校名・説明のキーワード（任意）。前後空白は除去し、空文字は undefined にする。
 */
export function buildFilterParams(conditions: FilterConditions, q?: string) {
  const trimmedQ = q?.trim()
  return {
    q: trimmedQ ? trimmedQ : undefined,
    prefectures: conditions.prefectures.length > 0 ? conditions.prefectures : undefined,
    collegeTypes: conditions.collegeTypes.length > 0 ? conditions.collegeTypes : undefined,
    studyFieldIds: conditions.studyFieldIds.length > 0 ? conditions.studyFieldIds : undefined,
    jobCategoryIds: conditions.jobCategoryIds.length > 0 ? conditions.jobCategoryIds : undefined,
    eventDateFrom: conditions.eventDateFrom ?? undefined,
    // 開始日のみ選択（eventDateTo が null）の場合は開始日を上限として使用（当日1日の件数を返すため）
    eventDateTo: conditions.eventDateTo ?? conditions.eventDateFrom ?? undefined,
    wishedOnly: conditions.wishedOnly,
  }
}
